export default {"src":"/_next/static/media/appleWhite.9eb4a5b2.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};